function clear_string(string) {
  return string.replaceAll('.', '').replaceAll('-', '').replaceAll(' ', '').replaceAll('/', '');
}

var product_list = {};
var search_query_static = "";
$(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
  search_query_static = params.q;
  data.items.forEach(function(item,index){
    if (item.metafield_b99b77ef8c5cb59e68a3f9998d477730) {
      product_list[item.product_id] = item.metafield_b99b77ef8c5cb59e68a3f9998d477730;
    }
  });
});
$(document).on('Searchanise.ResultsUpdated', function(event, container) {
  Object.entries(product_list).forEach(function(item) {
    var new_data = document.createElement('span');
    new_data.classList.add('new-data');
    new_data.setAttribute('data-metafield-value',item[1]);
    var metafield_value = item[1];
    var metafield_arr = metafield_value.split(',');
    metafield_arr.forEach(function(metafield_arr_item){
      if (container[0].querySelector('#snize-product-'+item[0]) && !container[0].querySelector('#snize-product-'+item[0]).querySelector('.new-data')) {
        var metafield_arr_item_sku = metafield_arr_item.split('|')[1];
        if (metafield_arr_item_sku.toLowerCase() == search_query_static.toLowerCase()) {
          new_data.innerHTML = metafield_arr_item_sku;
          container[0].querySelector('#snize-product-'+item[0]).querySelector('.snize-overhidden').append(new_data);
        }
        if (clear_string(metafield_arr_item_sku.toLowerCase()) == clear_string(search_query_static.toLowerCase())) {
          new_data.innerHTML = metafield_arr_item_sku;
          container[0].querySelector('#snize-product-'+item[0]).querySelector('.snize-overhidden').append(new_data);
        }
      }
    });
  });
});

$(document).on('Searchanise.AutocompleteUpdated', function(event, input, container) {
  var search_query = input[0].value;
  Object.entries(product_list).forEach(function(item) {
    var new_data = document.createElement('span');
    new_data.classList.add('new-data');
    new_data.setAttribute('data-metafield-value',item[1]);
    var metafield_value = item[1];
    var metafield_arr = metafield_value.split(',');
    metafield_arr.forEach(function(metafield_arr_item, index){
      if (container[0].querySelector('#snize-ac-product-'+item[0]) && !container[0].querySelector('#snize-ac-product-'+item[0]).querySelector('.new-data')) {
        var metafield_arr_item_sku = metafield_arr_item.split('|')[1];
        if (metafield_arr_item_sku.toLowerCase() == search_query.toLowerCase()) {
          new_data.innerHTML = metafield_arr_item_sku;
          container[0].querySelector('#snize-ac-product-'+item[0]+' .snize-title').classList.add('snize-title--bold');
          container[0].querySelector('#snize-ac-product-'+item[0]).querySelector('.snize-item').append(new_data);
        }
        if (clear_string(metafield_arr_item_sku.toLowerCase()) == clear_string(search_query.toLowerCase())) {
          new_data.innerHTML = metafield_arr_item_sku;
          container[0].querySelector('#snize-ac-product-'+item[0]+' .snize-title').classList.add('snize-title--bold');
          container[0].querySelector('#snize-ac-product-'+item[0]).querySelector('.snize-item').append(new_data);
        }
      }
    });
  });
});